var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("学校名称："+_vm._s(_vm.name))]),_vm._v(" "),_c('h2',[_vm._v("学校地址："+_vm._s(_vm.address))]),_vm._v(" "),_c('router-link',{attrs:{"replace":"","to":"/School/login"}},[_vm._v("学校嵌套的效果")]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('button',{on:{"click":_vm.shownames}},[_vm._v("这是一个按钮")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97fead40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/study/study3/School.vue
// module id = null
// module chunks = 